(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqDeleteController',DiscIbqDeleteController);

    DiscIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Disc'];

    function DiscIbqDeleteController($uibModalInstance, entity, Disc) {
        var vm = this;

        vm.disc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Disc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
